export const AMPLITUDE_PLUGIN_TYPES = {
    ENRICHMENT: 'enrichment',
};
